import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/shared/assets/img/call/icon-call.svg'
import _imports_1 from '@/projects/mti/assets/img/call/call-mobile.svg'


import WhatsAppUnavailable from '@/shared/components/Warnings/WhatsAppUnavailable.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'TheCall',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WhatsAppUnavailable, null, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("a", {
        href: "https://wa.me/79035192590",
        target: "_blank",
        class: "c-call__outer",
        "data-stickyeah-offset": "120"
      }, [
        _createElementVNode("div", { class: "c-call" }, [
          _createElementVNode("div", { class: "c-call__content" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }),
            _createElementVNode("div", { class: "c-call__text" }, [
              _createTextVNode("Напиши"),
              _createElementVNode("br"),
              _createTextVNode("менеджеру")
            ])
          ])
        ]),
        _createElementVNode("img", {
          src: _imports_1,
          class: "c-call__mobile",
          alt: ""
        })
      ], -1)
    ])),
    _: 1,
    __: [0]
  }))
}
}

})